module.exports = __webpack_public_path__ + "static/media/a5.74815462.png";